import React from 'react';
import { useDraggableContainer, } from './useDraggableContainer';
import classNames from 'classnames';
export function DraggableContainer(props) {
    const { dataHook, className, draggable, dragging, dragDisabled, dim, ...rest } = props;
    const { className: draggableClassName } = useDraggableContainer({
        draggable,
        dragging,
        dragDisabled,
        dim,
    });
    return (React.createElement("div", { "data-hook": dataHook, className: classNames(className, draggableClassName), ...rest }));
}
//# sourceMappingURL=DraggableContainer.js.map